import React, { useEffect, useState, useRef } from 'react';
import Box from '@mui/material/Box';
import { gsap } from 'gsap';
// import { data } from '../mock/mockDump';

const sonomaBounds = [
  { latitude: 38.167309043518166, longitude: -122.46494293212892 }, //upper left
  { latitude: 38.15730431188241, longitude: -122.45026588439943 }, // lower right
];

const Map = ({ coordinates, boundingDetails }) => {
  const scrubby = useRef(null);
  const tl = useRef();

  useEffect(() => {
    // console.log(data);
    tl.current = gsap.timeline();
    tl.current.pause();
    const calculatePixelPosition = (latitude, longitude) => {
      const x =
        (longitude - boundingDetails.origin.longitude) *
        boundingDetails.pixelsperdegree;
      const y =
        (latitude - boundingDetails.origin.latitude) *
        boundingDetails.pixelsperdegree;

      return { x, y };
    };
    // if (data) {
    //   data.forEach((record) => {
    //     // switched in source data, or some other problem.
    //     const longitude = record.metrics.LATITUDE[2];
    //     const latitude = record.metrics.LONGITUDE[2];
    //     console.log({ latitude: latitude, longitude: longitude });
    //     const { x, y } = calculatePixelPosition(latitude, longitude);
    //     // console.log(x, y);
    //     tl.current.to(scrubby.current, { x: x, y: y, duration: 1 });
    //   });
    // }

    // coordinates.forEach(({ latitude, longitude }) => {
    //   const { x, y } = calculatePixelPosition(latitude, longitude);
    //   console.log(x, y);
    //   tl.current.to(scrubby.current, { x: x, y: y, duration: 1 });
    // });
    // tl.current.resume();
    // console.log(coordinates);
    const { x, y } = calculatePixelPosition(
      coordinates?.latitude[2],
      coordinates?.longitude[2]
    );
    console.log(coordinates?.latitude[2], coordinates?.longitude[2]);
    console.log({ x, y });
    gsap.to(scrubby.current, { x: x, y: y });
  }, [coordinates, boundingDetails]);

  return (
    <>
      <Box
        sx={{
          width: boundingDetails.width,
          height: boundingDetails.height,
          border: '3px solid red',
        }}
      >
        <Box
          ref={scrubby}
          sx={{
            position: 'relative',
            bottom: '1rem',
            left: 0,
            width: '10px',
            height: '10px',
            borderRadius: '99px',
            backgroundColor: '#e55555',
            zIndex: 1,
          }}
        ></Box>
      </Box>
    </>
  );
};

// Example usage:
const PlotPointsTest = ({ my_data }) => {
  const [boundingDetails, setBoundingDetails] = useState(null);
  useState(() => {
    function boundingBoxConversion(
      boundingBoxCoords,
      pixelsPerDegree,
      desiredWidthInPixels
    ) {
      // latitude is zero at equater and increses towards north pole
      // longitude is greater negative (smaller) number towards the left (west)
      // lower left will be zero in absolute pixels
      let width, height, calculatedPixelsPerDegree;
      const latitude1 = boundingBoxCoords[0].latitude;
      const latitude2 = boundingBoxCoords[1].latitude;
      const longitude1 = boundingBoxCoords[0].longitude;
      const longitude2 = boundingBoxCoords[1].longitude;
      const lower = latitude1 < latitude2 ? latitude1 : latitude2; // lower numberic latitude is closer to equator
      const upper = latitude1 < latitude2 ? latitude2 : latitude1;
      const left = longitude1 < longitude2 ? longitude1 : longitude2;
      const right = longitude1 < longitude2 ? longitude2 : longitude1;
      const verticalDegrees = upper - lower;
      const horizontalDegrees = right - left;
      if (pixelsPerDegree > 0) {
        height = verticalDegrees * pixelsPerDegree;
        width = horizontalDegrees * pixelsPerDegree;
        calculatedPixelsPerDegree = pixelsPerDegree;
      } else if (desiredWidthInPixels) {
        console.log('use desired width');
        // need to return a height and pixelsPerDegree so it can be used elsewhere.
        calculatedPixelsPerDegree = desiredWidthInPixels / horizontalDegrees;
        console.log(desiredWidthInPixels / horizontalDegrees);
        height = verticalDegrees * calculatedPixelsPerDegree;
        width = desiredWidthInPixels;
      } else {
        console.log(
          'you need to provide a desired width or a pixels per degree'
        );
      }
      //   console.log(lower, upper, left, right, verticalDegrees, horizontalDegrees);
      //   console.log({ width: horizontalPixels, height: verticalPixels });
      return {
        width: width,
        height: height,
        origin: { latitude: lower, longitude: left },
        pixelsperdegree: calculatedPixelsPerDegree,
      };
    }
    setBoundingDetails(boundingBoxConversion(sonomaBounds, 0, 1000));
  }, []);

  const gpsCoordinates = [
    // { latitude: 37.7749, longitude: -122.4194 },
    { latitude: 38.167309043518166, longitude: -122.46494293212892 }, //upper left
    { latitude: 38.1605, longitude: -122.4542 },
    { latitude: 38.15730431188241, longitude: -122.45026588439943 }, // lower right
    // Add more coordinates as needed
  ];

  let myCoords;
  if (my_data) {
    const longitude = my_data?.slice(-1)[0]?.metrics.LATITUDE;
    const latitude = my_data?.slice(-1)[0]?.metrics.LONGITUDE;
    myCoords = { latitude: latitude, longitude: longitude };
    // console.log(myCoords);
  }

  return <Map coordinates={myCoords} boundingDetails={boundingDetails} />;
  //   return <Map coordinates={gpsCoordinates} boundingDetails={boundingDetails} />;
};

export default PlotPointsTest;
